// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","protectText":"Footer_protectText__7zs9r"};